import React from 'react';
import { useTranslation } from 'react-i18next';

import { Text } from '@/components/TextComponent';
import { Box } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { LineSteps } from '@/feature/invite-friends/components/LineSteps';
import { Rafv2DocumentDataActiveReferralsStepsItem } from '@/types/prismic.generated';

export type ActiveReferral = {
    receiverEmail: string;
    status: string;
};

//TODO: this component will use BE data: referral with/from user name, status, steps
export const ActiveReferrals = ({
    activeReferrals,
    steps,
}: {
    activeReferrals: ActiveReferral[];
    steps?: Rafv2DocumentDataActiveReferralsStepsItem[];
}) => {
    const { t } = useTranslation('raf');
    const { receiverEmail } = activeReferrals[0];

    return (
        <Box padding={'s16'} borderRadius={'r16'} borderWidth={1} borderColor={ds.colorToken.border.strong}>
            <Box pb={'s16'}>
                <Text variant={'titleLarge'}>
                    {t('sent_to')} {receiverEmail}
                </Text>
                <Text variant={'bodySmall'} color={ds.colorToken.text.secondary}>
                    {t('their_progress')}
                </Text>
            </Box>
            <LineSteps steps={steps} />
        </Box>
    );
};
